import { DYNAMIC_PROCESSES_EDITOR_PATH } from "@/modules/admin-panel/dynamic-processes/pages/dynamic-processes-editor";
import { generatePath, Navigate } from "react-router-dom";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

export function OpenDynamicProcess() {
  const url = new URL(window.location.href);
  const id = url.searchParams.get("id");

  if (!id) {
    return <ToPageNotFound />;
  }

  return <Navigate to={generatePath(DYNAMIC_PROCESSES_EDITOR_PATH, { id })} />;
}
